import React, { useState, useContext } from "react";
import { UserContext } from "../App";
const emailURL =
  "https://thrive-mqy3.onrender.com/v1/docs/#/Auth/post_auth_send_verification_email";
function EmailVerification() {
  const { userInfo } = useContext(UserContext);
  const [verify, setVerify] = useState("");
  const accessToken = localStorage.getItem("accessToken");

  const verifyEmail = async (e) => {
    e.preventDefault();

    try {
      const verifyDetails = {};

      const userDetail = {
        method: "POST",
        body: JSON.stringify(verifyDetails),
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "content-Type": "application/json",
        },
      };

      const response = await fetch(emailURL, userDetail);
      const data = await response.json();
      console.log("data", data);
    } catch (error) {
      console.log("something went wrong" + error);

      return;
    }
  };
  return (
    <div className="flex flex-col justify-center text-center bg-[#D4DDCC] h-[100vh] gap-4 text-[#295700] md:px-96 leading-8">
      <div className="bg-[#295700] w-fit p-4 mx-auto rounded-full">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="white"
          className="w-20 h-20"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
          />
        </svg>
      </div>

      <h1 className="font-bold  text-3xl">Please verify your email</h1>
      <p>
        You are almost there! We sent an email to <br />
        <span className="font-bold">{userInfo.email}</span>
      </p>
      <p>
        Just click on the link in your email to complete your account
        registration, if you don't see it, you may need to &nbsp;
        <span className="font-bold">check your spam</span> &nbsp;folder
      </p>
      <p>Still can't find the email? No problem</p>
      <button className="w-fit mx-auto rounded-md px-4 py-2 bg-[#295700] text-white mt-4">
        Resend Verification Email
      </button>
    </div>
  );
}

export default EmailVerification;
